import React, { useContext } from 'react';
import { Context, ACTIONS } from './store';

const Link = (props) => {
  const { dispatch } = useContext(Context);
  const style = { display: 'inline-block', cursor: 'pointer' };

  const gotoMenu = () => {
    dispatch({
      type: ACTIONS.GO_TO_MENU,
      payload: props.data,
    });
  };

  return (
    <div style={style} onClick={gotoMenu}>
      { props.children }
    </div>
  );
};

const Card = ({ data }) => {
  let list = null;
  let title = (<div className="menu-card-tt">{ data.title }</div>);

  if (!Array.isArray(data.items) || data.items.length < 1) {
    title = (<Link data={data}>{ title }</Link>);
  } else {
    list = (
      <ul className="menu-card-li">
        {
          data.items.map((item) => (
            <li key={item.title}>
              <Link data={item}>
                <span style={{ color: '#296bef' }}>
                  { item.title }
                </span>
              </Link>
            </li>
          ))
        }
      </ul>
    );
  }

  return (
    <div className="menu-card">
      <div className={['menu-card-icon', data.icon].join(' ')} />
      { title }
      { list }
    </div>
  );
};

const Home = ({ config }) => (
  <div className="help-menu">
    <div className="hd">Hi！选择帮助资源</div>
    { config.map((item) => (<Card key={item.title} data={item} />)) }
  </div>
);

export default Home;
